import ArrowLeftIcon from '@material-ui/icons/ArrowLeft'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import Error from '@material-ui/icons/Error'
import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../store/actions'
import WalidacjaErrorStyle from '../styles/WalidacjaErrorStyle'

class WalidacjaError extends React.Component {
  state = {
    isExpanded: false,
  }

  toggleExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  enter() {
    const {
      error,
      fileId,
      onDownloadSections,
      onSetActualValidityError,
      sections,
      onSaveSections,
      menu,
    } = this.props
    let page
    menu.forEach(x => {
      if (x.Sekcje.includes(error.TypSekcji)) page = x.Id
      else {
        x.Dzieci.forEach(y => {
          if (y.Sekcje.includes(error.TypSekcji)) {
            page = y.Id
          }
        })
      }
    })
    if (page) {
      onSetActualValidityError(error)
      onSaveSections(fileId, sections).then(() => {
        onDownloadSections(fileId, page).then(() => {
          const elements = document.getElementsByName(error.NazwaPola)
          if (elements && elements.length !== 0) {
            let isFocused = false
            for (var i = 0; i < elements.length; i++) {
              if (elements[i].value && elements[i].value === error.Wartosc) {
                elements[i].focus()
                isFocused = true
                break
              }
            }
            if (!isFocused) {
              if (elements[0]) {
                elements[0].focus()
              }
            }
          }
        })
      })
    }
  }

  getActualIndex = () => {
    const { error, errors } = this.props
    const sameError = errors.find(x => x === error)
    return errors.indexOf(sameError)
  }

  changeContext = offset => {
    const { onSetActualValidityError, errors } = this.props
    let index = this.getActualIndex() + offset
    if (index >= errors.length) return
    else if (index < 0) return
    onSetActualValidityError(errors[index])
  }

  render() {
    let { error, errors, changable } = this.props
    return (
      <WalidacjaErrorStyle>
        <div className="firstRow">
          <Error className="icon" />
          <div className="error">
            <p className="white-overline">
              BŁĄD {this.getActualIndex() + 1} Z {errors.length}
            </p>
            <p className="white-body-bold-2">
              {error.TytulPola}:{' '}
              <span className="white-body-2">{error.OpisBledu}</span>
            </p>
          </div>
          <div className="enterBtns">
            {changable && (
              <ArrowLeftIcon
                className={this.getActualIndex() <= 0 ? 'disabled' : ''}
                onClick={() => this.changeContext(-1)}
              />
            )}

            {error.TypSekcji !== 'Nieznana' ? (
              <p className="enter white-button" onClick={() => this.enter()}>
                PRZEJDŹ
              </p>
            ) : (
              <p className="enter white-button disabled">PRZEJDŹ</p>
            )}

            {changable && (
              <ArrowRightIcon
                className={
                  this.getActualIndex() === errors.length - 1 ? 'disabled' : ''
                }
                onClick={() => this.changeContext(1)}
              />
            )}
          </div>
          <p
            className="showMore white-button"
            onClick={() => this.toggleExpanded()}
          >
            {this.state.isExpanded ? 'MNIEJ' : 'WIĘCEJ'}
          </p>
        </div>
        {this.state.isExpanded && (
          <div className="secondRow">
            <div className="expandError">
              <p className="white-body-2">{error.Komunikat}</p>
            </div>
          </div>
        )}
      </WalidacjaErrorStyle>
    )
  }
}

const mapStateToProps = state => ({
  fileId: state.sprawozdanie.header.Id,
  sections: state.sprawozdanie.sections,
  menu: state.sprawozdanie.header.Menu,
})

const mapDispatchToProps = dispatch => ({
  onSetActualValidityError: err =>
    dispatch(actions.setActualValidityError(err)),
  onDownloadSections: (id, page) =>
    dispatch(actions.downloadSections(id, page)),
  onSaveSections: (id, s) => dispatch(actions.saveSections(id, s)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WalidacjaError)
